module.exports = __webpack_public_path__ + "img/Screen.e594baaf.svg";